import type { HeadersWithoutIterator } from 'owa-service/lib/RequestOptions';
import { setHeaders } from 'owa-headers-core';
import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';

export default function setExplicitLogonHeaders(
    smtp: string | undefined,
    headers: HeadersWithoutIterator | undefined | null,
    prefixedId?: string
): void {
    if (headers && (smtp || prefixedId)) {
        setHeaders(headers, getExplicitLogonHeaders(smtp, prefixedId));
    }
}
